var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"class_body_text"},[_c('div',{staticClass:"text_list"},[_vm._l((_vm.nameObj[_vm.name]),function(item,index){return _c('p',{key:index,staticClass:"text_list_item"},[_vm._v(" "+_vm._s(item)+" ")])}),_c('p',[_vm._v("研究方向如下：")])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }